<template>
  <div class="offcanvas offcanvas-end" tabindex="-1" id="examConsentOffcanvas" data-bs-backdrop="static" aria-labelledby="examConsentOffcanvasLabel" ref="offcanvasElement">
    <div class="offcanvas-header">
      <button class="btn-back" type="button" @click="doCancel" :disabled="loading">
        <IconArrowBack />
        {{ step === 'success' ? $t('close') : $t('goBack') }}
      </button>

      <div class="">
        <h5 class="offcanvas-title d-block no-wrap">{{ $t('examConsent.title') }}</h5>

        <div class="switch-language-box" v-if="step !== 'success' && step !== 'loading'">
          <div class="btn-group" role="group" aria-label="Switch language">
            <input type="radio" class="btn-check" name="switchLanguage" id="switchLanguageEN" autocomplete="off" :checked="consentLang === 'en'">
            <label class="btn btn-outline-secondary" for="switchLanguageEN" @click="switchLang('en')">EN</label>

            <input type="radio" class="btn-check" name="switchLanguage" id="switchLanguageES" autocomplete="off" :checked="consentLang === 'es'">
            <label class="btn btn-outline-secondary no-border-radius" for="switchLanguageES" @click="switchLang('es')">ES</label>

            <input type="radio" class="btn-check" name="switchLanguage" id="switchLanguageHT" autocomplete="off" :checked="consentLang === 'ht'">
            <label class="btn btn-outline-secondary" for="switchLanguageHT" @click="switchLang('ht')">HT</label>
          </div>
        </div>
      </div>
    </div>

    <div class="offcanvas-body" v-loader.opacity="loading">
      <!-- <div class="switch-language-box" v-if="step !== 'success' && step !== 'loading'">
        <div class="btn-group" role="group" aria-label="Switch language">
          <input type="radio" class="btn-check" name="switchLanguage" id="switchLanguageEN" autocomplete="off" :checked="consentLang === 'en'">
          <label class="btn btn-outline-secondary" for="switchLanguageEN" @click="switchLang('en')">EN</label>

          <input type="radio" class="btn-check" name="switchLanguage" id="switchLanguageES" autocomplete="off" :checked="consentLang === 'es'">
          <label class="btn btn-outline-secondary" for="switchLanguageES" @click="switchLang('es')">ES</label>
        </div>
      </div> -->

      <div class="no-results-box" v-if="step === 'no-templates'">
        <BaseNoResults :title="$t('examConsent.noTemplatesConfigured')" :text="$t('examConsent.configureTemplatesHint')"/>
      </div>

      <div v-if="step === 'select-template'">
        <h6 class="text-muted mb-3">{{ $t('examConsent.selectTemplate') }}</h6>
        <div class="d-grid gap-3">
          <div v-for="tmpl in consentTemplates"
               :key="tmpl.id"
               class="mode-card-horizontal"
               :class="{ active: selectedTemplate && selectedTemplate.id === tmpl.id }"
               @click="selectTemplate(tmpl)">
            <div class="d-flex align-items-center">
              <i class="fa fa-file-text-o me-3"></i>
              <div class="text-start">
                <h6 class="mb-0">{{ tmpl.name }}</h6>
                <p class="text-muted small mb-0">{{ tmpl.description }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- TODO: I'll return in a second stage -->
      <!-- <div v-if="step === 'fill-fields'" class="form-section">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h6 class="fw-bold mb-0 text-primary">{{ selectedTemplate.name }}</h6>
          <button v-if="consentTemplates.length > 1" class="btn btn-sm btn-link" @click="step = 'select-template'">
             {{ $t('examConsent.changeTemplate') }}
          </button>
        </div>

        <p class="text-muted small mb-3">{{ $t('examConsent.fillFieldsHint') }}</p>

        <div class="row g-3">
          <template v-for="field in selectedTemplate.formSchema" :key="field.key">
            <div class="col-12">
              <label class="form-label small fw-bold">{{ field.label }}</label>

              <div v-if="field.type === 'checkbox'" class="form-check form-switch">
                <input class="form-check-input" type="checkbox" v-model="dynamicFormData[field.key]">
              </div>

              <textarea v-else-if="field.type === 'textarea'" class="form-control" rows="3" v-model="dynamicFormData[field.key]"></textarea>

              <input v-else :type="field.type === 'date' ? 'date' : 'text'" class="form-control" v-model="dynamicFormData[field.key]">
            </div>
          </template>
        </div>
      </div> -->

      <div v-if="step === 'signature'" class="signature-box">
        <div>
          <h6>{{ $t('examConsent.previewTitle') }}</h6>
          <div class="text-preview-box scrollbar" v-html="processedHtml">
          </div>
          <!-- <div class="text-content" v-html="processedHtml"></div> -->
        </div>

        <div>
          <h6>{{ $t('examConsent.patientSignature') }}</h6>
          <div class="signature-dropzone">
            <div ref="signaturePad"></div>
            <button class="btn-remove-signature" @click="clearSignature" v-if="!loading">
              <IconCross />
            </button>
          </div>
        </div>
      </div>

      <div v-if="step === 'success'" class="success-box text-center">
        <IconCheckBig/>

        <div class="">
          <h1>{{ $t('examConsent.successTitle') }}</h1>
          <h6>{{ $t('examConsent.successMessage') }}</h6>
        </div>

        <button class="btn btn-success" type="button" data-test="btnDownloadPdf" @click="handleDownloadSuccess">
          {{ $t('examConsent.downloadSigned') }}
        </button>
      </div>

      <div class="offcanvas-footer" v-if="step !== 'success' && step !== 'loading' && step !== 'no-templates'">
        <button
          v-if="step === 'select-template'"
          class="btn btn-success"
          type="button"
          data-test="btnJNext"
          @click="goToFillFields"
          :disabled="!selectedTemplate || !isTemplateValid">
          {{ $t('examConsent.next') }}
        </button>

        <!-- TODO: I'll return in a second stage  -->
        <!-- <button
          v-if="step === 'fill-fields'"
          class="btn btn-success"
          type="button"
          data-test="btnGenerate"
          @click="goToFillFields">
          {{ $t('examConsent.advanceToSignature') }}
        </button> -->

        <div v-if="step === 'signature'">
          <p v-if="!isTemplateValid"
            class="invalid-template-alert">
            {{ $t('examConsent.invalidTemplateTags') }}
          </p>

          <button
            v-if="step === 'signature'"
            class="btn btn-success"
            type="button"
            data-test="btnSaveSigned"
            @click="saveFinalDocument"
            :disabled="!isTemplateValid">
            {{ $t('examConsent.saveSignedDocument') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.offcanvas {
  width:                              90% !important;

  .offcanvas-header {
    h5 {
      width:                          100%;
    }

    > div {
      display:                        flex;
      flex-direction:                 row;
      justify-content:                space-between;
      align-items:                    center;
    }

    .switch-language-box {
      display:                        flex;
      flex-direction:                 row;
      align-items:                    center;
    }

    .btn-group {
      .btn-outline-secondary:not(.dropdown-toggle) {
        @include                      border_radius(99px 0 0 99px);
        color:                        var(--Shades-70);
        font-size:                    12px;
        font-weight:                  400;
        line-height:                  normal;
        letter-spacing:               1.8px;
        text-transform:               uppercase;
        display:                      flex;
        justify-content:              flex-end;
        align-items:                  center;
        gap:                          10px;
        margin:                       0;
        padding:                      10px 15px;
        background:                   var(--Shades-W);
        border:                       1px solid var(--Shades-30-Border);

        &:focus,
        &:hover,
        &:active,
        &.active {
          color:                      var(--Complementary-Success);
          background:                 var(--Complementary-Success-BG);
          border:                     1px solid var(--Complementary-Success);
        }

        &.no-border-radius {
          @include                    border_radius(0);
        }

        &:last-child {
          @include                    border_radius(0 99px 99px 0);
          border-left:                0;
        }
      }

      > div {
        .btn-outline-secondary:not(.dropdown-toggle) {
          @include                    border_radius(99px 0 0 99px);
          border:                     1px solid var(--Shades-30-Border);
        }
      }

      .btn-check:checked+.btn-outline-secondary {
        color:                        var(--Complementary-Success);
        background:                   var(--Complementary-Success-BG);
        border:                       1px solid var(--Complementary-Success) !important;
      }
    }
  }

  .offcanvas-body {
    display:                          flex;
    flex-direction:                   column;
    gap:                              26px;
    overflow:                         hidden;

    h6 {
      font-size:                      var(--font-size-18) !important;
      color:                          var(--Brand-Primary) !important;
    }
  }

  .mode-card-horizontal {
    @include                          border_radius(10px);
    @include                          transition(0.2s);
    padding:                          15px;
    border:                           1px solid var(--Shades-60-Border);
    cursor:                           pointer;

    &:hover {
      border-color:                   var(--Brand-Primary);
    }
    &.active {
      border-color:                   var(--Brand-Primary);
      background:                     rgba(var(--Brand-Primary-rgb), 0.05);
    }
    i {
      color:                          var(--Brand-Primary);
      font-size:                      1.5rem;
    }

    h6 {
      font-size:                      var(--font-size-16);
      color:                          var(--Brand-Primary);
    }

    p {
      font-size:                      var(--font-size-14);
      color:                          var(--Brand-Primary) !important;
    }
  }

  .signature-dropzone {
    @include                          border_radius(10px);
    position:                         relative;
    overflow:                         hidden;
    max-height:                       100px;
    background:                       #fff;
    border:                           1px solid var(--Shades-60-Border);

    .btn-remove-signature {
      position:                       absolute;
      top:                            10px;
      right:                          10px;
      background:                     transparent;
      border:                         none;
      z-index:                        5;
    }
  }

  .signature-box {
    display:                          flex;
    flex-direction:                   column;
    gap:                              26px;
    flex:                             1;
    min-height:                       0;

    > div {
      &:first-child {
        flex:                         1;
        min-height:                   0;
        display:                      flex;
        flex-direction:               column;
        overflow:                     hidden;
      }

      &:last-child {
        flex:                         0 0 auto;
      }
    }
  }

  .text-preview-box {
    @include                          border_radius(10px);
    flex:                             1;
    min-height:                       0;
    padding:                          20px;
    overflow-y:                       auto;
    background:                       #fff;
    border:                           1px solid var(--Shades-60-Border);

    // .text-content {
      :deep(*) {
        font-size:                    var(--font-size-14);
        color:                        #000 !important;
      }

      :deep(h2) {
        font-size:                    var(--font-size-18);
      }

      :deep(h4) {
        font-size:                    var(--font-size-16);
      }
    // }
  }

  .success-box {
    display:                          flex;
    flex-direction:                   column;
    flex:                             1;
    align-items:                      center;
    justify-content:                  center;
    gap:                              26px;
    max-width:                        500px;
    margin:                           0 auto;

    h1,
    h6 {
      color:                          var(--Brand-Primary);
    }

    h1 {
      font-size:                      38px;
      font-weight:                    400;
      line-height:                    normal;
    }

    h6 {
      font-size:                      var(--font-size-14);
      font-weight:                    300;
      line-height:                    140%; /* 19.6px */
    }
  }

  .offcanvas-footer {
    display:                          flex;
    flex-direction:                   column;
    gap:                              26px;
  }

  .btn-success {
    font-size:                        var(--font-size-14);
    font-weight:                      700;
    line-height:                      normal;
    letter-spacing:                   4.2px;
    text-align:                       center;
    text-transform:                   uppercase;
    width:                            100%;
    max-width:                        350px;
    margin:                           0;
    padding:                          20px;
  }

  .invalid-template-alert {
    color:                            red !important;
    margin:                           0 !important;
    margin-bottom:                    5px !important;
  }
}

@media (max-width: 991px) {
  .offcanvas {
    width:                            100% !important;
    max-width:                        unset !important;
  }
}

@media (max-width: 767px) {
  .offcanvas {
    .offcanvas-header {
      overflow:                       hidden;

      h5 {
        margin:                       0 0 5px;
      }

      > div {
        flex-direction:               column;
        gap:                          5px;
        justify-content:              flex-start;
        align-items:                  flex-start;
      }
    }
  }
}
</style>

<script>
import { useUserStore } from '@/store/user';
import signature from '@lemonadejs/signature';
import EyercloudConstants from '@/utils/constants.js';

export default {
  name: 'ExamConsentOffcanvas',
  data: () => ({
    offcanvas_instance: null,
    loading: false,
    step: 'loading',
    examId: null,
    patientId: null,
    autoCreateExam: false,
    patientName: '',
    finalPdfUrl: null,
    savedFile: {},
    signatureComponent: null,
    consentTemplates: [],
    selectedTemplate: null,
    dynamicFormData: {},
    resolvePromise: null,
    session: {},
    patientDocument: '',
    patientDob: '',
    patientMrn: '',
    patientTelephone1: '',
    consentLang: 'en'
  }),
  mounted() {
    const userStore = useUserStore();
    this.session = userStore.sessionInfo;
  },
  computed: {
    isTemplateValid() {
      if (!this.selectedTemplate || !this.selectedTemplate.htmlContent)
        return false;

      const content = this.selectedTemplate.htmlContent;

      const hasName = content.includes('{{patient_name}}');
      const hasSignature = content.includes('{{patient_signature_img}}');

      return hasName && hasSignature;
    },
    processedHtml() {
      if (!this.selectedTemplate || !this.selectedTemplate.htmlContent)
        return '';

      let html = this.selectedTemplate.htmlContent;
      const payload = this.buildPayload();

      Object.keys(payload).forEach(key => {
        const regex = new RegExp(`{{${key}}}`, 'g');
        html = html.replace(regex, payload[key]);
      });

      return html;
    }
  },
  methods: {
    async show(options = {}) {
      this.resetForm();
      this.examId = options.examId || null;
      this.patientId = options.patientId || null;
      this.autoCreateExam = options.autoCreateExam || false;
      this.patientName = options.patientName || '';
      this.patientDob = options.patientDob || '';
      this.patientMrn = options.patientMrn || '';
      this.patientTelephone1 = options.patientTelephone1 || '';

      const el = document.getElementById("examConsentOffcanvas");
      if (el) {
        this.offcanvas_instance = bootstrap.Offcanvas.getOrCreateInstance(el);
        this.offcanvas_instance.show();
      }

      await this.loadTemplates();

      return new Promise((resolve) => { this.resolvePromise = resolve; });
    },
    async loadTemplates() {
      this.loading = true;
      try {
        const response = await this.$clinicService.listConsentTemplates({
          clinicID: this.session.currentClinic.id,
          lang: this.consentLang,
        });

        this.consentTemplates = response.result || [];

        if (this.consentTemplates.length === 1) {
          this.selectTemplate(this.consentTemplates[0]);
          this.step = 'signature';
          this.goToFillFields();
        } else if (this.consentTemplates.length > 1) {
          this.step = 'select-template';
        } else {
          this.step = 'no-templates';
        }
      } catch (err) {
        console.error('Error loading templates', err);
        this.step = 'no-templates';
      } finally {
        this.loading = false;
      }
    },
    async switchLang(lang) {
      if (this.consentLang === lang || this.loading) return;
      this.consentLang = lang;
      await this.loadTemplates();
    },
    selectTemplate(template) {
      this.selectedTemplate = template;
      this.dynamicFormData = {};
      if (template.formSchema) {
        for (const field of template.formSchema) {
          if (field.type === 'checkbox') {
            this.dynamicFormData[field.key] = false;
          } else if (field.key.includes('name') && field.type === 'text') {
            this.dynamicFormData[field.key] = this.patientName || '';
          } else if (field.key.includes('date') && field.type === 'date') {
            this.dynamicFormData[field.key] = new Date().toISOString().split('T')[0];
          } else {
            this.dynamicFormData[field.key] = '';
          }
        }
      }
    },
    goToFillFields() {
      if (!this.selectedTemplate) return;
      // this.step = 'fill-fields';
      this.step = 'signature';
      this.$nextTick(() => {
        this.initSignature();
      });
    },
    toTitleCase(str) {
      if (!str) return str;
      return str.toLowerCase().replace(/\b\w/g, c => c.toUpperCase());
    },
    buildPayload(signatureBase64 = '') {
      const payload = {
        patient_name: this.toTitleCase(this.patientName),
        patient_document: this.patientDocument || '',
        patient_dob: this.patientDob || '',
        patient_mrn: this.patientMrn || '',
        patient_telephone1: this.patientTelephone1 || '',
        current_date: moment().format(this.$i18n.t('dateTimeFormat')),
        clinic_name: this.session.currentClinic.name
      };

      if (this.selectedTemplate && this.selectedTemplate.formSchema) {
        for (const field of this.selectedTemplate.formSchema) {
          payload[field.key] = this.dynamicFormData[field.key] || '';
        }
      }

      if (signatureBase64) {
        payload.patient_signature_img = `<img src="${signatureBase64}" style="max-height: 40px; width: auto;" />`;
        payload.signature_date = new Date().toLocaleDateString();
      } else {
        payload.patient_signature_img = '';
        payload.signature_date = '';
      }

      return payload;
    },
    wrapHtmlContent(quillHtml) {
      const sanitizedHtml = quillHtml
        .replace(/<br>/g, '<br />');

      return `<!DOCTYPE html>
        <html>
        <head>
        <meta charset="UTF-8" />
        <style>
          html, body { margin: 0; padding: 0; font-family: sans-serif; font-size: 12px; color: #000; }
          @page { size: A4; margin: 25mm 20mm 25mm 20mm; }
          h1 { font-size: 18px; text-align: center; margin-bottom: 15px; }
          h2 { font-size: 15px; margin-bottom: 10px; }
          h3 { font-size: 13px; margin-bottom: 8px; }
          p { margin: 4px 0; line-height: 1.5; }
          ul, ol { margin: 4px 0 4px 20px; }
          .signature-line { border-bottom: 1px solid #000; width: 60%; height: 35px; margin-top: 30px; }
        </style>
        </head>
        <body>
        ${sanitizedHtml}
        </body>
        </html>`;
      },
    initSignature() {
      if (this.$refs.signaturePad) {
        this.$refs.signaturePad.innerHTML = '';
        const containerWidth = this.$refs.signaturePad.clientWidth || 600;
        this.signatureComponent = signature(this.$refs.signaturePad, {
          width: containerWidth,
          height: 100,
          // instructions: this.$t('examConsent.signatureInstructions'),
        });
      }
    },
    clearSignature() {
      this.initSignature();
    },
    ensureMinimumPayloadSize(payload, minBytes = 10000) {
      const json = JSON.stringify(payload);
      const currentSize = new TextEncoder().encode(json).length;

      if (currentSize >= minBytes) {
        return payload;
      }

      const paddingNeeded = minBytes - currentSize;
      
      payload.data._padding = "x".repeat(paddingNeeded);

      return payload;
    },
    async saveFinalDocument() {
      const canvas = this.$refs.signaturePad.querySelector('canvas');

      const isCanvasEmpty = (canvas) => {
        const blank = document.createElement('canvas');
        blank.width = canvas.width;
        blank.height = canvas.height;
        return canvas.toDataURL() === blank.toDataURL();
      };

      if (!canvas || isCanvasEmpty(canvas)) {
        this.$message.popup(this, 'examConsent.signatureRequired', 'operationFail', 'warn');
        return;
      }

      this.loading = true;

      try {
        if (this.autoCreateExam && this.patientId) {
          const examResponse = await this.$patientService.saveExam({
            id: this.patientId,
            exam: { date: new Date(), mydriasis: false }
          });
          this.examId = examResponse.result.id;
        }

        const signatureBase64 = canvas.toDataURL('image/png');
        const payload = this.buildPayload(signatureBase64);
        const fullHtml = this.selectedTemplate.htmlContent
          ? this.wrapHtmlContent(this.selectedTemplate.htmlContent)
          : null;

        let params = {
          htmlTemplate: fullHtml,
          data: payload,
          type: EyercloudConstants.EXAM_CONSENT_TYPE
        };

        params = this.ensureMinimumPayloadSize(params);

        const responseData = await this.$examDataService.generateConsentPdf(params);

        if (responseData.url && responseData.uuid) {
          const payloadOthers = {
            clinicID: this.session.currentClinic.id,
            examId: this.examId,
            type: 'OTHER_CONSENT_PDF',
            description: `${this.$i18n.t('examConsent.fileName')} - ${this.selectedTemplate?.name}`,
            uuid: responseData.uuid,
            s3Key: responseData.uuid,
            extension: 'pdf',
            originalName: `${this.$i18n.t('examConsent.fileName')}.pdf`
          };

          this.savedFile = await this.$examDataService.saveOthers(payloadOthers);

          this.finalPdfUrl = responseData.url;
          this.step = 'success';

          if (this.resolvePromise) {
            this.resolvePromise(true);
          }

          this.$message.popup(this, this.$t('examConsent.successSaved'), 'operationSuccess', 'success');
        }
      } catch (err) {
        console.error(err);
        this.$message.popup(this, this.$t('examConsent.errorSavingDocument'), 'operationFail', 'error');
      } finally {
        this.loading = false;
      }
    },
    handleDownloadSuccess() {
      NProgress.start();
      this.loading = true;

      try {
        let el = document.createElement('a');
        el.href = this.finalPdfUrl;
        el.target = '_blank';
        el.rel = 'noopener noreferrer';

        document.body.appendChild(el);
        el.click();
        document.body.removeChild(el);
      } catch (err) {
        console.error("Error downloading file:", err);
        this.$message.popup(this, 'request_error', 'operationFail', 'error');
      } finally {
        NProgress.done(true);
        this.loading = false;
      }
    },
    resetForm() {
      this.step = 'loading';
      this.examId = null;
      this.patientId = null;
      this.autoCreateExam = false;

      if (this.finalPdfUrl)
        URL.revokeObjectURL(this.finalPdfUrl);

      this.finalPdfUrl = null;
      this.selectedTemplate = null;
      this.dynamicFormData = {};
      this.consentTemplates = [];

      if (this.$refs.signaturePad)
        this.$refs.signaturePad.innerHTML = '';
    },
    doCancel() {
      if (this.loading)
        return;

      if (this.offcanvas_instance)
        this.offcanvas_instance.hide();

      this.resetForm();
      if (this.resolvePromise)
        this.resolvePromise(false);
    }
  }
};
</script>
